import DashboardIcon from '@mui/icons-material/Dashboard';
import DashboardIcon2 from '@mui/icons-material/DashboardOutlined';
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RateReviewIcon from '@mui/icons-material/RateReview';
import UsersIcon from '@mui/icons-material/PeopleAlt';
import PaletteIcon from '@mui/icons-material/Palette';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import PhoneIcon from '@mui/icons-material/Phone';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import PowerIcon from '@mui/icons-material/Power';
import NotificationsIcon from '@mui/icons-material/NotificationsActive';
import CodeIcon from '@mui/icons-material/Code';
import QuickreplyIcon2 from '@mui/icons-material/QuickreplyOutlined';
import AccountCircleIcon2 from '@mui/icons-material/AccountCircleOutlined';
import RateReviewIcon2 from '@mui/icons-material/RateReviewOutlined';
import UsersIcon2 from '@mui/icons-material/PeopleAltOutlined';
import PaletteIcon2 from '@mui/icons-material/PaletteOutlined';
import PersonPinIcon2 from '@mui/icons-material/PersonPinOutlined';
import GroupAddIcon2 from '@mui/icons-material/GroupAddOutlined';
import CreditCardIcon2 from '@mui/icons-material/CreditCardOutlined';
import EventRepeatIcon2 from '@mui/icons-material/EventRepeatOutlined';
import RequestQuoteIcon2 from '@mui/icons-material/RequestQuoteOutlined';
import PhoneIcon2 from '@mui/icons-material/PhoneOutlined';
import DynamicFormIcon2 from '@mui/icons-material/DynamicFormOutlined';
import AccessTimeFilledIcon2 from '@mui/icons-material/AccessTimeFilledOutlined';
import PowerIcon2 from '@mui/icons-material/PowerOutlined';
import NotificationsIcon2 from '@mui/icons-material/NotificationsActiveOutlined';
import DesktopPhoneIcon from '@mui/icons-material/Fax';
import DesktopPhoneIcon2 from '@mui/icons-material/FaxOutlined';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import FEATURES from 'constants/features';
import { MODULES } from 'constants/permissions';

export default [
  {
    label: 'Personal Settings',
    items: [
      {
        label: 'Profile',
        description:
          'Manage your personal account information, preferences, and login credentials.',
        to: '/settings/profile',
        icon: AccountCircleIcon,
        icon2: AccountCircleIcon2,
      },
      {
        label: 'Call Routing',
        description:
          'Set how incoming calls are routed across all your devices.',
        to: '/settings/call-routing',
        icon: PhoneCallbackIcon,
        icon2: PhoneCallbackIcon,
      },
    ],
  },
  {
    label: 'Account',
    items: [
      // {
      //   label: 'Overview',
      //   to: '/settings/overview',
      //   icon: DashboardIcon,
      //   icon2: DashboardIcon2,
      //   showInOverview: false,
      // },
      {
        label: 'Users',
        description:
          'Add, remove, or modify team member access and permissions within the system.',
        to: '/settings/users',
        icon: UsersIcon,
        icon2: UsersIcon2,
      },
      // {
      //   label: 'Notifications',
      //   description:
      //     'Configure how and when you receive alerts and updates about system activities.',
      //   to: '/settings/notifications',
      //   icon: NotificationsIcon,
      //   icon2: NotificationsIcon2,
      // },
      {
        label: 'Branding',
        description:
          "Personalize the visual elements like logos, colors, and styling to match your company's identity.",
        to: '/settings/branding',
        icon: PaletteIcon,
        icon2: PaletteIcon2,
      },
      {
        label: 'Sender Profile',
        description:
          'Customize the identity and contact details that appear when sending messages to customers.',
        to: '/settings/sender-profile',
        icon: PersonPinIcon,
        icon2: PersonPinIcon2,
      },
      {
        label: 'Refer a Friend',
        description:
          'Share your experience and invite others to use the platform with referral incentives.',
        to: '/settings/referrals',
        icon: GroupAddIcon,
        icon2: GroupAddIcon2,
      },
    ],
    color: 'primary',
  },
  {
    label: 'Billing',
    items: [
      {
        label: 'Payment',
        description:
          'Manage your billing information and update payment cards or accounts.',
        to: '/settings/payment',
        icon: CreditCardIcon,
        icon2: CreditCardIcon2,
        access: MODULES.BILLING,
      },
      {
        label: 'Subscriptions',
        description:
          'Review and modify your current subscription plan and billing cycle details.',
        to: '/settings/subscription',
        icon: EventRepeatIcon,
        icon2: EventRepeatIcon2,
        access: MODULES.BILLING,
      },
      {
        label: 'Invoices',
        to: '/settings/invoices',
        description:
          'Access and download your billing history and payment records.',
        icon: RequestQuoteIcon,
        icon2: RequestQuoteIcon2,
        access: MODULES.BILLING,
      },
    ],
    color: 'success',
  },
  {
    label: 'System',
    items: [
      {
        label: 'Phone Numbers',
        to: '/settings/phone-numbers',
        description:
          'Manage phone numbers associated with your account for messaging and calling.',
        icon: PhoneIcon,
        icon2: PhoneIcon2,
      },
      {
        label: 'Desktop Phones',
        to: '/settings/desktop-phones',
        description: 'Manage and organize desktop phone numbers.',
        icon: DesktopPhoneIcon,
        icon2: DesktopPhoneIcon2,
        features: [FEATURES.TALK_OPERATOR],
      },
      {
        label: 'Contact Fields',
        to: '/settings/custom-fields',
        description:
          'Customize and organize the information fields you collect about your contacts.',
        icon: DynamicFormIcon,
        icon2: DynamicFormIcon2,
        adminOnly: true,
      },
      {
        label: 'After Hours Reply',
        to: '/settings/after-hours-reply',
        description:
          'Set up automated responses for messages received outside of business hours.',
        icon: AccessTimeFilledIcon,
        icon2: AccessTimeFilledIcon2,
      },
      {
        label: 'Message Templates',
        to: '/settings/templates',
        description:
          'Create and manage reusable message formats for consistent communication.',
        icon: RateReviewIcon,
        icon2: RateReviewIcon2,
      },
      {
        label: 'Message Variables',
        to: '/settings/variables',
        description:
          'Define dynamic content placeholders that automatically populate in your messages.',
        icon: QuickreplyIcon,
        icon2: QuickreplyIcon2,
      },
      {
        label: 'Integrations',
        to: '/settings/integrations',
        description:
          'Connect and configure third-party tools and services with your account.',
        icon: PowerIcon,
        icon2: PowerIcon2,
        features: [
          FEATURES.PCO,
          FEATURES.MC,
          FEATURES.CCB,
          FEATURES.DIGIGIV,
          FEATURES.ZAPIER,
          FEATURES.ROCK,
          FEATURES.ELVANTO,
        ],
      },
      {
        label: 'Developer',
        to: '/settings/developer',
        description:
          'Access API keys, webhooks, and app integrations for developers.',
        icon: CodeIcon,
        icon2: CodeIcon,
        features: [FEATURES.DEVELOPER_ACCESS],
      },
    ],
    color: 'warning',
  },
];
